import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface GetICSBulkConsignmentHistoryInterface {
  take?: number
  skip?: number
  status?: any
  bulkReferance?: any
  filterVariables?: any
  splitReferance?: any
}

export const useGetICSBulkConsignmentHistory = () => {
  const mutate = useMutation(
    ({
      take,
      skip,
      status,
      filterVariables,
      bulkReferance,
      splitReferance,
    }: GetICSBulkConsignmentHistoryInterface) => {
      return postAPI(`/ICSBulkConsignmentSummary`, {
        take,
        skip,
        status,
        bulkReferance,
        principle: filterVariables?.principle?.label,
        consNo: '',
        bulkSlipNo: filterVariables?.bulkSlipNo ?? '',
        user: filterVariables?.user?.label,
        createdFrom: filterVariables?.createdFrom ?? '',
        createdTo: filterVariables?.createdTo ?? '',
        consignedFrom:
          status != 'Pending' && status != 'InProgress'
            ? filterVariables?.consignedFrom
            : '',
        consignedTo:
          status != 'Pending' && status != 'InProgress'
            ? filterVariables?.consignedTo
            : '',
        splitReferance: splitReferance ?? '',
      })
    },
  )

  return mutate
}

export default useGetICSBulkConsignmentHistory
